import { useState, useContext, useEffect } from "react";
import { Container, Button, Card, Modal } from "react-bootstrap";
import {
  ArrowLeft,
  User,
  MapPin,
  Target,
  Car,
  Coins,
  UserX,
  Navigation,
  Clock,
  MessageSquare,
  Users as UsersIcon,
  AlertCircle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../../../components/Customer/general/BottomNav";
import "../../../assets/css/Customer/general/BottomNav.css";
import "../../../assets/css/Customer/CustomerDashboard/CustomerFindingDriver.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const CustomerFindingDriver = () => {
  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [bookings, setBookings] = useState([]);
  const [rebidPrices, setRebidPrices] = useState({});
  const { baseUrl, selectedRideforFindingDriver, setSelectedRideforFindingDriver, authToken } = useContext(AppContext);

  const cancelReasons = [
    { id: 1, text: "Driver asks for extra fare", icon: Coins },
    { id: 2, text: "Driver asked me to cancel", icon: UserX },
    { id: 3, text: "Driver asked to go directly", icon: Navigation },
    { id: 4, text: "Wait time was too long", icon: Clock },
    { id: 5, text: "Driver doesn't answer", icon: MessageSquare },
    { id: 6, text: "Complaint about the rider", icon: UsersIcon },
    { id: 7, text: "Driver getting closer", icon: AlertCircle },
  ];

  const handleSkip = () => {
    setShowCancelModal(true);
  };

  const handleAccept = (booking) => {
    const formData = new FormData();
    formData.append("id", booking.id);

    axios.post(`${baseUrl}/customer/ride/acceptBid`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((response) => {
      if (response.data.success === true) {
        localStorage.setItem("selectedDriver", JSON.stringify(booking));
        setSelectedRideforFindingDriver({
          ...selectedRideforFindingDriver,
          status: "accept",
          bookingBiddings: [{ ...booking, status: "accepted" }]
        });
        navigate("/customer-accept-ride");
      }
    }).catch(() => alert("Network Error!"));
  };

  const handleRebid = (booking) => {
    const price = rebidPrices[booking.id];
    if (!price) {
      alert("Please enter a price to rebid");
      return;
    }

    const formData = new FormData();
    formData.append("id", booking.id);
    formData.append("crossbidprice", price);

    axios
      .post(`${baseUrl}/customer/ride/crossBid`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          setBookings((prev) =>
            prev.map((b) =>
              b.id === booking.id
                ? { ...b, iscrossbidded: true, crossbidprice: price }
                : b
            )
          );
          setRebidPrices((prev) => ({ ...prev, [booking.id]: "" }));
        }
      })
      .catch(() => alert("Network Error!"));
  };

  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  const handleCloseFirstModal = () => {
    setShowCancelModal(false);
  };

  const handleYesCancel = () => {
    setShowCancelModal(false);
    setShowReasonModal(true);
  };

  const handleCloseReasonModal = () => {
    setShowReasonModal(false);
    setSelectedReason("");
  };

  const handleReasonSelect = (reasonId) => {
    setSelectedReason(reasonId);
  };

  const handleFinalCancel = () => {
    navigate("/customer-dashboard");
  };

  const fetchbookingbidding = () => {
    const formData = new FormData();
    formData.append("tdride_id", selectedRideforFindingDriver?.id);

    axios
      .post(`${baseUrl}/customer/ride/viewBidding`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("bid received:", response.data);
        console.log("response", response.data);

        if (response.data.success === true) {
          const authToken = localStorage.getItem("authToken");

          setBookings(response.data.biddings);
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  useEffect(() => {
    console.log(selectedRideforFindingDriver);
    fetchbookingbidding("");
  }, []);

  return (
    <div className="cfd-wrapper">
      <div className="cfd-header">
        <Button
          variant="link"
          onClick={() => navigate(-1)}
          className="cfd-back-btn"
        >
          <ArrowLeft size={20} />
        </Button>
        <span className="cfd-header-title">Finding Driver</span>
        <div className="cfd-header-spacer"></div>
      </div>

      <Container className="cfd-container">
        {bookings.map((booking) => (
          <Card key={booking.tddriver?.id} className="cfd-driver-card">
            <Card.Body>
              <div className="cfd-driver-header">
                <div className="cfd-driver-info">
                  <div className="cfd-driver-avatar">
                    <User size={24} />
                  </div>
                  <div>
                    <div
                      className="cfd-driver-name"
                      style={{ fontWeight: "bold" }}
                    >
                      {booking.tddriver?.drivername}
                    </div>
                    <div className="cfd-vehicle-type">
                      {selectedRideforFindingDriver?.vehicleType}
                    </div>
                  </div>
                </div>
                <div className="cfd-price">Rs.{booking.bidAmounts}</div>
              </div>

              <div className="cfd-driver-meta">
                <div className="cfd-rating">
                  ⭐ 5
                </div>
                <div className="cfd-date">
                  {selectedRideforFindingDriver?.bookingDate}
                </div>
              </div>

              <div className="cfd-rebid-row">
                <input
                  type="number"
                  placeholder="Enter your price"
                  className="cfd-rebid-input"
                  value={rebidPrices[booking.id] || ""}
                  onChange={(e) =>
                    setRebidPrices((prev) => ({ ...prev, [booking.id]: e.target.value }))
                  }
                  disabled={booking.iscrossbidded}
                />
                <Button
                  className="cfd-rebid-btn"
                  onClick={() => handleRebid(booking)}
                  disabled={booking.iscrossbidded}
                >
                  {booking.iscrossbidded ? "Rebid Sent" : "Rebid"}
                </Button>
              </div>

              <div className="cfd-actions">
                <Button
                  variant="outline"
                  className="cfd-skip-btn"
                  onClick={handleSkip}
                >
                  Skip
                </Button>
                <Button
                  className="cfd-accept-btn"
                  onClick={() => handleAccept(booking)}
                >
                  Accept
                </Button>
              </div>
            </Card.Body>
          </Card>

        ))}

        <Card className="cfd-ride-details-card">
          <Card.Body>
            <div className="cfd-ride-header">
              <div className="cfd-vehicle-icon">
                <Car size={32} />
              </div>
              <div className="cfd-ride-price-info">
                <div className="cfd-ride-price-label">
                  Rs.
                  {selectedRideforFindingDriver?.offeredFare == ""
                    ? 100
                    : selectedRideforFindingDriver?.offeredFare}{" "}
                  for private ride
                </div>
              </div>
            </div>
            <div className="cfd-ride-meta">
              <div className="cfd-ride-date">
                {selectedRideforFindingDriver?.bookingDate}
              </div>
              <div className="cfd-ride-payment">
                {selectedRideforFindingDriver?.paymentmethod}
              </div>
            </div>
            <div className="cfd-locations">
              <div className="cfd-location-item">
                <MapPin size={18} className="cfd-location-icon-pickup" />
                <span className="cfd-location-text">
                  {selectedRideforFindingDriver?.pickuplocation}
                </span>
              </div>
              <div className="cfd-location-divider"></div>
              <div className="cfd-location-item">
                <Target size={18} className="cfd-location-icon-dropoff" />
                <span className="cfd-location-text">
                  {selectedRideforFindingDriver?.dropofflocation}
                </span>
              </div>
            </div>
          </Card.Body>
        </Card>

        <Button className="cfd-cancel-btn" onClick={handleCancelClick}>
          CANCEL
        </Button>
      </Container>

      <Modal
        show={showCancelModal}
        onHide={handleCloseFirstModal}
        centered
        className="cfd-cancel-modal"
      >
        <Modal.Body className="text-center p-4">
          <h5 className="mb-4">Are you sure you want to cancel?</h5>
          <div className="d-flex justify-content-between gap-3">
            <Button
              variant="light"
              className="w-100"
              onClick={handleCloseFirstModal}
            >
              No
            </Button>
            <Button
              className="cfd-modal-yes-btn w-100"
              onClick={handleYesCancel}
            >
              Yes, Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showReasonModal}
        onHide={handleCloseReasonModal}
        centered
        className="cfd-reason-modal"
      >
        <Modal.Body className="p-4">
          <h5 className="mb-4">Why do you want to cancel?</h5>
          <div className="cfd-reason-list">
            {cancelReasons.map((reason) => (
              <div
                key={reason.id}
                className={`cfd-reason-item ${selectedReason === reason.id ? "cfd-reason-selected" : ""}`}
                onClick={() => handleReasonSelect(reason.id)}
              >
                <span className="cfd-reason-text">{reason.text}</span>
              </div>
            ))}
          </div>
          <Button
            className="cfd-reason-close-btn w-100 mt-4"
            onClick={handleFinalCancel}
            disabled={!selectedReason}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>
      <BottomNav />
    </div>
  );
};

export default CustomerFindingDriver;